var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordConfirm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8537 23.14L18.4987 21.75L21.1438 23.141L20.6387 20.195L22.7788 18.11L19.8217 17.68L18.4987 15L17.1757 17.679L14.2188 18.109L16.3588 20.195L15.8537 23.14Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0556 10H18.1111V9C18.1111 8.08075 17.9401 7.1705 17.6079 6.32122C17.2756 5.47194 16.7887 4.70026 16.1748 4.05025C15.5609 3.40024 14.8321 2.88463 14.03 2.53284C13.2279 2.18106 12.3682 2 11.5 2C10.6318 2 9.77213 2.18106 8.97004 2.53284C8.16794 2.88463 7.43914 3.40024 6.82524 4.05025C6.21134 4.70026 5.72437 5.47194 5.39213 6.32122C5.05989 7.1705 4.88889 8.08075 4.88889 9V10H3.94444C3.69396 10 3.45374 10.1054 3.27662 10.2929C3.0995 10.4804 3 10.7348 3 11V21C3 21.2652 3.0995 21.5196 3.27662 21.7071C3.45374 21.8946 3.69396 22 3.94444 22H14.3333V20H4.88889V12H18.1111V14H20V11C20 10.7348 19.9005 10.4804 19.7234 10.2929C19.5463 10.1054 19.306 10 19.0556 10ZM12.4444 18V14H10.5556V18H12.4444ZM16.2222 9V10H6.77778V9C6.77778 7.67392 7.2753 6.40215 8.16088 5.46447C9.04647 4.52678 10.2476 4 11.5 4C12.7524 4 13.9535 4.52678 14.8391 5.46447C15.7247 6.40215 16.2222 7.67392 16.2222 9Z",
    fill: "#AAAAAA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPasswordConfirm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/password-confirm.21e857560eaf7a3b7792349da9555ccf.svg";